import React from 'react';
import {
  Box, Container, Typography, Accordion, AccordionSummary, AccordionDetails,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { motion } from 'framer-motion';
import homeSeo from '../seo/homeSeoData.json';

// English homepage FAQ — also emitted as FAQPage JSON-LD for rich results.
// Content lives in src/seo/homeSeoData.json so scripts/inject-seo.js can bake the
// same FAQPage/HowTo JSON-LD into the prerendered homepage HTML.
export const HOME_FAQS = homeSeo.faqs;
export const HOME_STEPS = homeSeo.steps;

export default function FaqSection() {
  return (
    <Box component="section" sx={{ py: { xs: 8, md: 12 }, background: 'linear-gradient(180deg, transparent, rgba(99,102,241,0.03))' }}>
      <Container maxWidth="md">
        <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }}>
          <Typography variant="h2" align="center" sx={{
            mb: { xs: 4, md: 6 }, fontSize: { xs: '1.75rem', md: '2.5rem' },
            background: (theme) => theme.palette.mode === 'dark'
              ? 'linear-gradient(135deg, #f1f5f9, #818cf8)'
              : 'linear-gradient(135deg, #111827, #6366f1)',
            WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text',
          }}>
            Frequently Asked Questions
          </Typography>
        </motion.div>
        {HOME_FAQS.map((f, i) => (
          <Accordion key={i} elevation={0} disableGutters
            sx={{ mb: 1.5, borderRadius: '12px !important', border: '1px solid rgba(99,102,241,0.12)', '&:before': { display: 'none' } }}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography fontWeight={600} component="h3" sx={{ fontSize: '1rem' }}>{f.q}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography color="text.secondary" sx={{ lineHeight: 1.7 }}>{f.a}</Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </Container>
    </Box>
  );
}
